/** All routes are kept absolute to allow direct navigation to a route, without chaining route-segments together. */
const Routes = {
  index: '/',
  account: {
    confirm: '/account/confirm',
    reconfirm: '/account/reconfirm',
    login: '/account/login',
    profile: '/account/profile',
  },

  cases: {
    index: '/arende',
    case: '/arende/:id',
  },

  notFound: '/not-found',

  purchases: { index: '/inkop', case: '/inkop/:id' },
  auction: { index: '/auktionsbilar', case: '/auktionsbilar/:id' },
  rentedStaff: { index: '/uthyrd-personal', case: '/uthyrd-personal/:id' },
  samakning: { index: '/samakning', case: '/samakning/:id' },
  homeDeliveries: { index: '/hemleveranser', case: '/hemleveranser/:id' },
  internalDeliveries: {
    index: '/annons',
    case: '/annons/:id',
  },
  internalDeliverySales: {
    index: '/annons-salj',
    case: '/annons-salj/:id',
  },
  facilityToFacility: {
    index: '/butik-till-butik',
    case: '/butik-till-butik/:id',
  },
  facilityTransfer: {
    index: '/flytt-mellan-anlaggningar',
    case: '/flytt-mellan-anlaggningar/:id',
  },
  verkstadsbilar: {
    index: '/verkstadsbilar',
    case: '/verkstadsbilar/:id',
  },
  facilityExchange: {
    index: '/anlaggningsinbyte',
    case: '/anlaggningsinbyte/:id',
  },
  rmOther: { index: '/rm-other', case: '/rm-other/:id' },
  avyttringar: { index: '/avyttringar', case: '/avyttringar/:id' },
  garantiarenden: { index: '/garantiarenden', case: '/garantiarenden/:id' },
  aterTillLogistik: {
    index: '/ater-till-logistik',
    case: '/ater-till-logistik/:id',
  },
  dackkorning: { index: '/dackkorning', case: '/dackkorning/:id' },
  swamp: { index: '/sumpen', case: '/sumpen/:id' },

  testDrives: {
    index: '/testkorning',
    case: '/testkorning/:id',
  },

  pendingAssignments: {
    index: '/mellanlandningar',
    case: '/mellanlandningar/:id',
  },

  viktigt: { index: '/viktigt', case: '/viktigt/:id' },

  skaPaLastbil: {
    index: '/ska-pa-lastbil',
    case: '/ska-pa-lastbil/:id',
  },

  transportLogistics: {
    index: '/transportledning',
    dayPlanning: '/transportledning/dagsplanering',
    dayPlanningFieldTester: '/transportledning/dagsplanering/:userId',
    followUp: '/transportledning/uppfoljning',
    routePlanning: '/transportledning/ruttplanering',
    routePlanFeedback: '/transportledning/ruttfeedback',
  },

  sharebox: { index: '/sharebox' },

  startklar: { index: '/startklar' },

  goSupport: {
    index: '/gosupport',
  },

  afterControl: {
    index: '/efterkontroll',
    speeding: '/efterkontroll/hastighet-gps',
    autoApproval: {
      index: '/efterkontroll/auto-approval',
      case: '/efterkontroll/auto-approval/:id',
    },
  },

  autoApproveAnalytics: {
    index: '/autogodkannande-analys',
    // Ärendemodal öppnad från analysen, så att man står kvar på analysen när
    // modalen stängs (i stället för att hamna på /efterkontroll).
    case: '/autogodkannande-analys/:id',
  },

  quality: {
    index: '/kvalitet',
    speeding: '/kvalitet/hastighet-gps',
    declined: '/kvalitet/nekade-uppdrag',
    bulkSms: '/kvalitet/sms-utskick',
    // Ärendemodal öppnad från Kvalitet. Egen route (i stället för
    // /efterkontroll/auto-approval/:id) så att admins med kvalitetsrollen men
    // utan Efterkontroll-rollen inte blir utslängda av Efterkontrolls rollspärr.
    case: '/kvalitet/uppdrag/:id',
  },

  hr: {
    index: '/hr',
    greenplates: '/hr/gronskyltar',
    lasDays: '/hr/las-dagar',
    workTimeReport: '/hr/tidsrapport',
  },

  rideUpdates: {
    index: '/uppdateringar',
    case: '/uppdateringar/:id',
  },

  rideWaitingList: {
    index: '/vantlista',
    case: '/vantlista/:id',
  },

  forgot: { index: '/forgot' },
  resetpassword: { index: '/resetpassword' },
  caseAssignmentRequests: { index: '/requests' },

  excelExports: {
    index: '/underlag',
    exports: '/underlag',
    history: '/underlag/historik',
    receipts: '/underlag/kvitton',
    lineItems: '/underlag/kvittorader',
    lineItem: '/underlag/kvittorader/:id',
    unclosedCases: '/underlag/ostangda-arenden',
  },
  employees: {
    index: '/anstallda',
    mobile: '/anstallda/mobil',
    timeReports: '/anstallda/tidrapporter',
    teams: '/anstallda/team',
    availability: '/anstallda/tillganglighet',
    absenceRequests: '/anstallda/tillganglighet/att-hantera',
    drivingPolicyWarnings: '/anstallda/tillganglighet/varningar',
    drivingPolicy: '/anstallda/tillganglighet/kortidpolicy',
    paymentCards: '/anstallda/betalkort',
  },
  ekonomi: {
    index: '/ekonomi',
    priceLists: '/ekonomi/prislistor',
  },
  companies: { index: '/addressbok' },
  dayPlanning: {
    index: '/transportledning/dagsplanering',
    fieldTester: '/transportledning/dagsplanering/:userId',
  },
  search: { index: '/sok', case: '/sok/:id' },
  case: { index: '/arende', case: '/arende/:id' },
  placeholder: { index: '/placeholder', case: '/placeholder/:id' },
  carTransportTrucks: {
    index: '/biltransport-lastbilar',
    case: '/biltransport-lastbilar/:id',
  },

  map: { index: '/map' },

  test: { index: '/test' },

  appInstall: { index: '/app-install' },

  privacy: { index: '/integritetspolicy' },

  kpis: {
    index: '/nyckeltal',
    riddermark: '/nyckeltal-riddermark',
    managementReport: '/ledningsrapport',
  },

  settings: {
    index: '/settings',
    businessUnits: '/settings/affarsomraden',
    holidays: '/settings/holidays',
    zipCodeAreas: '/settings/postnummeromraden',
    standardizedComments: '/settings/kommentarer',
    globalSettings: '/settings/globala-installningar',
    estimateDurations: '/settings/estimattider',
    productExpenseTypeMappings: '/settings/produkt-kostnadstyper',
    companyDepartments: '/settings/avdelningar',
    vehicleClassification: '/settings/fordonsklassificering',
    driverSwapPoints: '/settings/skiftespunkter',
    truckShareTarget: '/settings/annons-lastbil',
    // Fliken Ruttplanering — åtkomst per användare via GlobalSetting 116.
    routePlanning: {
      index: '/settings/ruttplanering',
      positions: '/settings/ruttplanering/positioner',
      homeAnchorMapping: '/settings/ruttplanering/hemankare',
      feedbackSample: '/settings/ruttplanering/ruttprov',
      globalSettings: '/settings/ruttplanering/installningar',
    },
    // Gamla adresser — omdirigeras till fliken Ruttplanering så att bokmärken fortsätter fungera.
    legacyHomeAnchorMapping: '/settings/hemankare',
    legacyRoutePlanFeedbackSample: '/settings/ruttprov',
  },

  internalDeliveryGroup: {
    // Vy för annons-uppdragen, otilldelade, planerade, utdelade, inkomna från Riddermark
    index: '/annons-v2',
    assignments: {
      index: '/annons-v2/uppdrag',
      case: '/annons-v2/uppdrag/:id',
    },
    carTransportTrucks: {
      index: '/annons-v2/biltransport-lastbilar',
      case: '/annons-v2/biltransport-lastbilar/:id',
    },
    testDrives: {
      index: '/annons-v2/testkorningar',
      case: '/annons-v2/testkorningar/:id',
    },
    // Vy för att hantera inkomna annonsbegäranden/äskningar
    requests: {
      index: '/annons-v2/forfragningar',
      request: '/annons-v2/forfragningar/:id',
    },
    // Vy för att hantera och följa upp budget
    overview: '/annons-v2/overview',
    // Vy för budget-/annonsinställningar
    budget: '/annons-v2/budget',
  },

  tests: {
    testMessageGenerator: '/tests/testMessageGenerator',
    testAIPrompt: 'tests/testAIPrompt',
    testAIInference: '/tests/testAIInference',
    // Dold felsökningsvy för Google Maps-nycklar, bara SuperAdmin.
    testMapsApiKey: '/tests/kartnyckel',
  },
} as const;

export default Routes;
